import { render, staticRenderFns } from "./pointsRecord.vue?vue&type=template&id=f78247a4&scoped=true"
import script from "./pointsRecord.vue?vue&type=script&lang=js"
export * from "./pointsRecord.vue?vue&type=script&lang=js"
import style0 from "./pointsRecord.vue?vue&type=style&index=0&id=f78247a4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f78247a4",
  null
  
)

export default component.exports